<template>
    <div>
        <label class="col-form-label pt-0">{{ label }}</label>
        <b-nav-item-dropdown
            :text="text"
            left
            extra-toggle-classes="navbar-filter"
            extra-menu-classes="w-100">
            <b-dropdown-item v-on:click="onSelect(null)">-- All --</b-dropdown-item>
            <template v-if="initialized">
                <b-dropdown-item
                    v-for="value in values"
                    v-on:click="onSelect(value)"
                    :key="value.label"
                    >{{__(value.label, ['titleCase'])}}</b-dropdown-item>
            </template>
        </b-nav-item-dropdown>
    </div>
</template>
<script>

export default {
    data() {
        return {
            initialized: false,
            currentValue: null,
        }
    },

    props: ['value', 'changeFilter', 'addFilter', 'removeFilter', 'config'],

    mounted() {
        this.initialized = true;
    },

    computed: {
        label() {
            const { name } = this.config;
            return `Filter by ${name}`;
        },
        text() {
            if (this.currentValue) {
                const label = this.__(this.currentValue.label, ['titleCase']);
                return label;
            }

            return '-- All --';
        },
        values() {
            return this._.get(this.config, 'options', []);
        },
        field() {
            return this._.get(this.config, 'field', null);
        }
    },

    watch: {
        value(newValue) {
            this.currentValue = newValue;
        }
    },

    methods: {
        onSelect(value) {
            this.$emit('input', value);

            if (!value) {
                this.removeFilter(this.field);
                return this.changeFilter();
            }

            if (!_.isArray(value.range)) return;
            const [min, max] = value.range;

            this.changeFilter(this.field, `$range(${min},${max})`);
        }
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/helpers/RangeFilterComponent.vue